import { useEffect } from 'react';
import Recall from '../model/Recall';
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import firebase_app from '../api/firebase';
import AppConfig from '../model/AppConfig';

const useGetRecalls = (
  appConfigDict,
  setLoading,
  setAllRecalls
) => {

  useEffect(() => {
    const documentListeners = {};

    const getRecalls = async (firebaseDocumentPath) => {
      const db = getFirestore(firebase_app);
      console.log("Listening to ...", firebaseDocumentPath);

      const listenerUnsubscribe =
        onSnapshot(doc(db, firebaseDocumentPath), (doc) => {
          const data = doc.data();
          if (data != null) {
            const recallObj = Object.values(data); //array
  
            let source = firebaseDocumentPath;
            const newRecalls = recallObj.reduce((map, item) => {
              const recall = new Recall(item, source);
              map[recall.compositeId] = recall;
              return map;
            }, {});
  
            // console.log(source, newRecalls);
  
            setAllRecalls(prevRecalls => ({
              ...prevRecalls,
              ...newRecalls
            }));
            setLoading(false);
          } else {
            setLoading(true);
          }
        });
  
      return listenerUnsubscribe;
    };

    const appConfigInstance = new AppConfig(appConfigDict);
    const documentIds = appConfigInstance.getFirebaseDocumentIds();

    //Start with a clean slate
    setAllRecalls({});

    (async () => {
      for (const documentId of documentIds) {
        const firebaseDocumentPath = appConfigInstance.getFirebaseDocumentPathV2(documentId);
        documentListeners[documentId] = await getRecalls(firebaseDocumentPath);
      }
    })();

    return (() => {
      for (const documentId in documentListeners) {
        console.log(`Unsub from ${documentId} recalls...`);
        if (documentListeners[documentId]) {
          documentListeners[documentId](); // Properly unsubscribe
        }
      }
    });
  }, [appConfigDict, setAllRecalls, setLoading]);
};

export default useGetRecalls;
